import * as $ from 'jquery';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, LocationStrategy, registerLocaleData, PathLocationStrategy } from '@angular/common';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// perfect-scrollbar
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';

// Shared
import { SharedModule } from '@shared/shared.module';
import { CanActivateAuthGuard, CanActivateRegisterAccountGuard } from '@shared/CanActivateAuthGuard';

// Navigation
import { BreadcrumbComponent } from './layouts/full/breadcrumb//breadcrumb.component';
import { NavigationComponent } from '@shared/header-navigation/navigation.component';

// Layouts
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { LandingComponent } from './layouts/landing/landing.component';
import { VerifyAccountComponent } from './layouts/verify-account/verify-account.component';

import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';

// Services
import { SessionManager } from '@services/session-manager';
import { UrlSerializer } from '@angular/router';
import { AssignmentCodeUrlSerializer } from '@shared/assignment-code-url-serializer';

import { ScrollingModule } from '@angular/cdk/scrolling';

// Set global language to es-CR
import localeEsCr from '@angular/common/locales/es-CR';

import { ToastrModule } from 'ngx-toastr';

// import { provideServiceWorker } from '@angular/service-worker';
// import { environment } from '../environments/environment';



registerLocaleData(localeEsCr);


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    wheelSpeed: 2,
    wheelPropagation: true,
};

@NgModule({
    declarations: [
        AppComponent,
        // Components
        // Navigation
        NavigationComponent,
        // Layouts
        BreadcrumbComponent,
        BlankComponent,
        FullComponent,

        LandingComponent,
        VerifyAccountComponent, 
    ],
    imports: [ 
        // Common
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        NgbModule,
        ReactiveFormsModule,
        AppRoutingModule,
        // Shared
        SharedModule, 
        ScrollingModule,
        ToastrModule.forRoot({timeOut: 3000, positionClass: 'toast-bottom-right', preventDuplicates: true})
    ],
    providers: [
        // provideServiceWorker('ngsw-worker.js', {
        //     enabled: environment.production,
        // }),
        SessionManager,
        // CanActivate
        CanActivateAuthGuard,
        CanActivateRegisterAccountGuard,
        // Providers
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        {
            provide: LocationStrategy,
            // DEPLOY ADMIN: use HashLocationStrategy
            // useClass: HashLocationStrategy
            // DEPLOY MARKET: use PathLocationStrategy
            useClass: PathLocationStrategy
        },
        { provide: LOCALE_ID, useValue: "es-CR" },
        // QR masivo (/pl-aa/...): el codigo base64 puede traer '//' y Angular cortaba la URL
        { provide: UrlSerializer, useClass: AssignmentCodeUrlSerializer }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
